export default __webpack_public_path__ + "static/media/data-review.1bc51226.svg";